export class Point {
  name?: string;
  title?: string;
  description?: string;
  unitOfMeasure?: string;
  current?: any;
  previous?: any;
  diffPercentage?: any;
}



// WEBPACK FOOTER //
// ./src/app/models/pointWidget.model.ts